/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Cash_NetInputs */

const vi_cashflow_cash_net = /** @type {(inputs: Cashflow_Cash_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt ròng`)
};

/**

* @param {Cashflow_Cash_NetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_cash_net = /** @type {((inputs?: Cashflow_Cash_NetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Cash_NetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_cash_net(inputs)
});